module.exports = __webpack_public_path__ + "img/bit2me.5f5622c6.png";